const PrimitiveForm = require('hooks/useFormPrimitives/PrimitiveForm');

module.exports = PrimitiveForm;
module.exports.internals = PrimitiveForm.internals;
